import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import PublicPageLayout from '../AppLayout/PublicPageLayout';
import PublicLayoutHeader from '../AppLayout/PublicLayoutHeader';
import { palette } from '../../assets/styles/themes/tokens';
import useRouter from '../../utils/useRouter';
import { routes } from '../../constants';
import MuLogo from '../AppLayout/SideNavbar/MuLogo';
import { customSizes } from '../../assets/styles/themes/tokens';
import { getNavWrapperStyles } from '../AppLayout/SideNavbar/SideNavbar';
import useScreenSize from '../../utils/useScreenSize';
export interface PublicContentLayoutProps {
  children: ReactNode;
  topRightComponent?: ReactNode;
}

const PublicContentLayout: React.FC<PublicContentLayoutProps> = ({
  children,
  topRightComponent,
}) => {
  const { router } = useRouter();
  const { isXsScreen, isSmScreen } = useScreenSize();
  const isSmallScreen = isXsScreen || isSmScreen;
  const navWrapperStyles = getNavWrapperStyles(true);

  const handleLogoClick = () => {
    router.push(`/${routes.login.root}`);
  };

  const content = (
    <Box sx={{ display: 'flex', height: '100%', width: '100%', backgroundColor: palette.background.default }}>
      {!isSmallScreen && (
        <Box
          sx={{
            ...navWrapperStyles,
            height: '100%',
          }}
        >
          <MuLogo 
            variant='small' 
            onClick={handleLogoClick} 
            sx={{ 
              height: customSizes.sideNavbar.headerHeight.desktop, 
              borderBottom: `1px solid ${palette.elevation.outlined}`, 
              width: '100%',
              borderRadius: 'none',
            }} 
          />
        </Box>
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <PublicLayoutHeader rightContent={topRightComponent} />
        <Box
          sx={{
            overflow: 'auto',
            height: '100%',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );

  return (
    <PublicPageLayout>
      {content}
    </PublicPageLayout>
  );
};

export default PublicContentLayout;

